import { a as a$1 } from './chunk-O54VISTG.mjs';
import { b, a } from './chunk-6EFRS222.mjs';
import { useEffect } from 'react';
import { Content, Title, Close, Description, DialogClose, Root, Trigger, Portal } from '@radix-ui/react-dialog';
import e, { css } from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var p=e.div`
  @keyframes overlayShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  z-index: var(--z-index-200);
  background-color: var(--overlay-100);
  position: fixed;
  inset: 0;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
`,t=e.div`
  display: flex;
  gap: var(--spacing-regular);
  justify-content: right;
`,E=css`
  width: 416px;
  max-width: calc(100vw - var(--spacing-x-large) * 2);
  padding: var(--spacing-x-large);
  ${t} {
    margin-top: var(--spacing-x-large);
  }
`,M=css`
  width: 920px;
  max-width: calc(100vw - var(--spacing-x-large) * 2);
`,d=e(Content)`
  @keyframes contentShow {
    from {
      opacity: 0;
      transform: translate(-50%, -48%) scale(0.96);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  z-index: var(--z-index-200);
  color: var(--${b});
  ${a};
  background-color: var(--background-level-1);
  border-radius: var(--border-radius-small, 6px);
  box-shadow: var(--elevation-400);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: min(416px, calc(100vw - var(--spacing-x-large) * 2));
  width: var(--content-modal-width);
  max-width: calc(100vw - var(--spacing-x-large) * 2);
  max-height: 100vh;
  overflow: auto;
  padding: var(--spacing-x-x-large);
  animation: contentShow 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  gap: var(--spacing-regular);
  flex-direction: column;

  ${t} {
    margin-top: var(--spacing-x-x-large);
  }

  ${({$size:o})=>o==="small"&&E}
  ${({$size:o})=>o==="large"&&M}
`,m=e(Title)`
  ${a$1};
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
`,g=e(Close)`
  color: var(--${b});
  position: absolute;
  top: var(--spacing-large);
  right: var(--spacing-large);
  border: none;
  background: none;
  cursor: pointer;
`;var x=({children:o,trigger:i,size:u="regular",modal:f=!0,open:r,onOpenChange:h,onOpenAutoFocus:y,onInteractOutside:b,onPointerDownOutside:w,container:C=document.body,...T})=>(useEffect(()=>(document.body.style.overflow=r?"hidden":"",()=>{document.body.style.overflow="";}),[r]),jsxs(Root,{modal:f,open:r,onOpenChange:h,...T,children:[i&&jsx(Trigger,{asChild:!0,children:i}),jsxs(Portal,{container:C,children:[jsx(p,{}),jsx(d,{$size:u,onOpenAutoFocus:y,onInteractOutside:b,onPointerDownOutside:w,children:o})]})]}));x.displayName="Modal";var R={Root:x,Title:m,Description:Description,Close:g,Actions:t,DialogClose:DialogClose};

export { R as a };
